import { IInformeRendimentos } from '@core/models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

interface IInformeRendimentosState {
    data: IInformeRendimentos;
    loading: boolean;
    error: string | null;
}

const initialState: IInformeRendimentosState = {
    data: {} as IInformeRendimentos,
    error: null,
    loading: false
};

export const informeRendimentosSlice = createSlice({
    name: 'informeRendimentos',
    initialState,
    reducers: {
        informe_rendimentos_fetching: (state) => {
            state.loading = true;
            state.data = {} as IInformeRendimentos;
            state.error = null;
        },
        informe_rendimentos_success: (state, action: PayloadAction<IInformeRendimentos>) => {
            state.data = action.payload;
            state.loading = false;
            state.error = null;
        },
        informe_rendimentos_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
            state.data = {} as IInformeRendimentos;
        }
    }
});

export const { informe_rendimentos_fetching, informe_rendimentos_success, informe_rendimentos_error } = informeRendimentosSlice.actions;

export const selectorInformeRendimentos = (state: AppState) => state.informeRendimentos;

export default informeRendimentosSlice.reducer;
